export default {
  'app.pwa.offline': 'أنت غير متصل حاليا',
  'app.pwa.serviceworker.updated': 'تتوفر محتويات جديدة',
  'app.pwa.serviceworker.updated.hint':
    'الرجاء النقر على زر التحديث لإعادة التحميل',
  'app.pwa.serviceworker.updated.ok': 'تحديث',
};
